import { ConverterType } from '../domain';
export const timestamp = {
    types: ['google.protobuf.Timestamp'],
    [ConverterType.TO_JSON]: {
        transform: (val) => (!val ? val : val.toISOString()),
    },
    [ConverterType.FROM_JSON]: {
        transform: (val) => (val ? new Date(val) : val),
    },
};
//# sourceMappingURL=timestamp.js.map